
      const GTM_KEY_DEFAULT = 'GTM-WXDJ5W5';
      const HEAP_KEY_DEFAULT = '1720263729';
      const HEAP_URL_DEFAULT = 'app.homebuddy.com';

      window.env = {};
      let counter = 0;

      function externalScripts() {
        // Start GTM
        const GTMKey = window.env.GTM_KEY || GTM_KEY_DEFAULT;

        if (GTMKey) {
          (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
          })(window, document, 'script', 'dataLayer', GTMKey);
          console.log('GTM has been loaded');
        }
        // END GTM

        // Start Heap IO
        const heapKey = window.env.HEAP_KEY || HEAP_KEY_DEFAULT;
        const heapUrl = window.env.HEAP_URL || HEAP_URL_DEFAULT;

        if (heapKey && window.location.hostname === heapUrl) {
          (window.heap = window.heap || []),
            (heap.load = function (e, t) {
              (window.heap.appid = e), (window.heap.config = t = t || {});
              var r = document.createElement('script');
              (r.type = 'text/javascript'),
                (r.async = !0),
                (r.src = 'https://cdn.heapanalytics.com/js/heap-' + e + '.js');
              var a = document.getElementsByTagName('script')[0];
              a.parentNode.insertBefore(r, a);
              for (
                var n = function (e) {
                    return function () {
                      heap.push([e].concat(Array.prototype.slice.call(arguments, 0)));
                    };
                  },
                  p = [
                    'addEventProperties',
                    'addUserProperties',
                    'clearEventProperties',
                    'identify',
                    'resetIdentity',
                    'removeEventProperty',
                    'setEventProperties',
                    'track',
                    'unsetEventProperty',
                  ],
                  o = 0;
                o < p.length;
                o++
              )
                heap[p[o]] = n(p[o]);
            });
          heap.load(env.HEAP_KEY || HEAP_KEY_DEFAULT);
          console.log('HEAP has been loaded');
        }
        // End HEAP IO
      }

      async function loadEnv() {
        const res = await fetch('/stats.json');

        if (!res.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const data = await res.json();

        return data;
      }

      async function loadData() {
        try {
          window.env = await loadEnv();
          externalScripts();

          await import('./src/app/index.tsx');
        } catch (err) {
          counter++;

          if (counter >= 5) {
            window.env = {
              version: 'fallback',
              GTM_KEY: GTM_KEY_DEFAULT,
              HEAP_KEY: HEAP_KEY_DEFAULT,
              HEAP_URL: HEAP_URL_DEFAULT,
            };

            externalScripts();

            await import('./src/app/index.tsx');

            throw new Error(`Stats JSON has not been downloaded 5+ times: ${err}`);
          }

          await loadData();
        }
      }

      (async () => {
        await loadData();
      })();
    